import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

export const bootstrap = new BootstrapBrowserBuilder('rental-growth-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({ logPath: `/rental-manager/growth/log` })
  .withDatadogPlugin('065be6c0-823e-4dca-a456-25275eb8a575', 'pub1bc89cfe2cfc245cef04c36f8ad301b9')
  .withOnRegister(analytics.initialize)
  .build();
